<template>
  <div class="property-staff-page">
    <div class="property-white-card">
      <div class="property-page-header">
        <div class="property-page-title">员工管理</div>
        <div class="property-header-divider"></div>
        <div class="property-header-row">
          <div class="property-btn-group">
            <el-button size="small" class="property-btn-refresh" title="刷新" @click="loadData(1, page.size)"><i class="el-icon-refresh-right"></i></el-button>
          </div>
          <div class="property-search-group">
            <el-input v-model="staffInfo.conditions.name" placeholder="请输入" size="small" class="property-search-input" clearable @keyup.enter.native="_queryStaffMethod" />
            <el-button size="small" class="property-btn-search" @click="_queryStaffMethod"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="property-table-section">
        <el-table v-loading="loading" :data="staffData" style="width: 100%" :fit="true" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column label="人脸" min-width="88" align="center">
            <template slot-scope="scope">
              <el-image class="staff-avatar" :src="getStaffPhoto(scope.row)" :preview-src-list="[getStaffPhoto(scope.row)]" fit="cover" />
            </template>
          </el-table-column>
          <el-table-column prop="userId" label="员工编号" min-width="170" show-overflow-tooltip />
          <el-table-column label="小区" min-width="170" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="132" show-overflow-tooltip />
          <el-table-column prop="tel" label="联系电话" min-width="132" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="170" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column label="状态" min-width="96">
            <template slot-scope="scope">{{ getStaffStatusName(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="96">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link danger" @click="openDeleteStaff(scope.row)">删除</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="property-pagination">
        <span class="pagination-total">共{{ page.total }}条</span>
        <el-pagination :current-page="page.current" :page-size="page.size" layout="prev, pager, next" :total="page.total" @current-change="handleCurrentChange" />
        <el-select v-model="page.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <delete-staff ref="deleteStaff" @success="handleSuccess" />
  </div>
</template>

<script>
import { queryStaffInfos } from '@/api/staff/staffApi'
import DeleteStaff from '@/components/staff/deleteStaff'

export default {
  name: 'PropertyStaffManageList',
  components: { DeleteStaff },
  data() {
    return {
      loading: false,
      staffInfo: { conditions: { name: '', tel: '', staffId: '' } },
      staffData: [],
      page: { current: 1, size: 10, total: 0 },
      currentStaff: {}
    }
  },
  created() { this.loadData(1, this.page.size) },
  methods: {
    async loadData(page, size) {
      try {
        this.loading = true
        const { staffs, total } = await queryStaffInfos({ page: page || this.page.current, row: size || this.page.size, ...this.staffInfo.conditions })
        this.staffData = staffs || []
        this.page.total = Number(total || 0)
      } catch (error) {
        this.$message.error(error.message || '获取员工列表失败')
      } finally {
        this.loading = false
      }
    },
    _queryStaffMethod() { this.page.current = 1; this.loadData(1, this.page.size) },
    openDeleteStaff(staff) { this.currentStaff = { ...staff }; this.$refs.deleteStaff.open(staff) },
    getStaffPhoto(staff) {
      if (staff.photoUrl) return staff.photoUrl
      if (staff.urls && staff.urls.length) return staff.urls[0]
      return '/img/noPhoto.jpg'
    },
    getStaffStatusName(staff) {
      return staff.statusCd === '1' ? '离职' : '在职'
    },
    handleSuccess() { this.loadData(this.page.current, this.page.size) },
    handleSizeChange(size) { this.page.size = size; this.page.current = 1; this.loadData(1, size) },
    handleCurrentChange(current) { this.page.current = current; this.loadData(current, this.page.size) },
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' } },
    cellStyle({ row }) {
      const rowIndex = this.staffData.indexOf(row)
      return { background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
    }
  }
}
</script>

<style lang="scss" scoped>
.property-staff-page { padding: 20px; background: #EBF2FA; min-height: calc(100vh - 100px); }
.property-white-card { background: #fff; border-radius: 12px; padding: 22px 24px; min-height: calc(100vh - 120px); }
.property-page-title { color: #1D2129; font: 600 16px/22px 'PingFang SC', sans-serif; }
.property-header-divider { height: 1px; background: #DCE6F5; margin: 18px -24px 22px; }
.property-header-row, .property-btn-group, .property-search-group, .action-links, .property-pagination { display: flex; align-items: center; }
.property-header-row { justify-content: space-between; gap: 12px; margin-bottom: 24px; }
.property-btn-group, .property-search-group { gap: 12px; }
.property-search-group { justify-content: flex-end; flex: 1; }
.property-btn-add, .property-btn-refresh, .property-btn-search { height: 38px; border-radius: 10px; padding: 0 16px; font: 500 14px/38px Inter, 'PingFang SC', sans-serif; }
.property-btn-add { background: #0E76FF; border-color: #0E76FF; color: #fff; }
.property-btn-refresh { width: 38px; padding: 0; background: #fff; border-color: #DCE6F5; color: #8C9BB4; }
.property-btn-search { background: #fff; border-color: #0E76FF; color: #0E76FF; }
.property-search-input { width: 220px; }
::v-deep .property-search-input .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; }
.property-table-section { border-radius: 10px; overflow: hidden; }
.staff-avatar { width: 42px; height: 42px; border-radius: 8px; background: #C4DDFF; }
.action-link { color: #0E76FF; cursor: pointer; }
.action-link.danger { color: #FB2C36; }
.link-separator { width: 1px; height: 14px; background: #DCE6F5; margin: 0 8px; }
.property-pagination { justify-content: flex-end; gap: 8px; margin-top: 20px; }
.pagination-total { color: #1D2129; font: 500 14px/22px 'PingFang SC', sans-serif; }
.pagination-size-select { width: 90px; }
::v-deep .pagination-size-select .el-input__inner { height: 32px; border: 0; border-radius: 8px; background: #F2F3F5; }
</style>
